import { useEffect, useState } from "react";

/**
 * Hook: 监听页面路由状态
 *
 * 职责：
 * - 判断当前是否在详情页 Modal 中
 * - 监听 URL 变化（popstate、pushState、replaceState）
 *
 * @param enabled - 是否启用（默认 true）。当为 false 时，不监听路由变化
 * @returns {Object} { isDetailPageOpen: boolean }
 */
export function usePageRouteState(enabled = true) {
  // 初始状态：检查当前 URL 是否是详情页
  const [isDetailPageOpen, setIsDetailPageOpen] = useState(() => {
    // 在服务端渲染时，window 可能不存在，默认返回 false
    if (typeof window === "undefined") return false;
    return window.location.pathname.startsWith("/pins/");
  });

  useEffect(() => {
    // AB 未开启时跳过所有监听逻辑
    if (!enabled) return;

    const checkRoute = () => {
      const isDetailPage = window.location.pathname.startsWith("/pins/");
      setIsDetailPageOpen(isDetailPage);
    };

    checkRoute();
    window.addEventListener("popstate", checkRoute);

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      setTimeout(checkRoute, 0);
    };

    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      setTimeout(checkRoute, 0);
    };

    return () => {
      window.removeEventListener("popstate", checkRoute);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, [enabled]);

  return { isDetailPageOpen };
}
